
import { removeHtml, toRussianLocaleDateFromIso } from '@packages/toolbox';
import { computed, defineComponent, PropType } from 'vue';
import { useRouter } from 'vue-router';

import { UsefulLinks } from 'SharedDir/declarations/useful-links';
import SBtn from 'SharedComponents/ui/Button/SBtn.vue';
import { useDeviceSize } from 'SharedDir/common/composables/useDeviceSize';
import { cropTextSmart } from 'SharedDir/utils/helpers';
import { ATTACHMENT_ENDPOINTS } from 'SharedDir/backend/endpoints/attachments';

export default defineComponent({
  name: 'UsefulLinkItem',
  components: { SBtn },
  props: {
    link: {
      type: Object as PropType<UsefulLinks.UsefulLinksFull>,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props) {
    const router = useRouter();

    const hasLogo = computed(() => {
      return props.link?.imageId !== null;
    });

    const getLinkName = computed(() => {
      return props.link?.name ?? '';
    });

    const getLinkShortDescription = computed(() => {
      return cropTextSmart(removeHtml(props.link?.shortDescription), 172) ?? '';
    });

    const getLinkDate = computed(() => {
      return props.link?.createdAt ? toRussianLocaleDateFromIso(props.link?.createdAt) : '';
    });

    const hasLinks = computed(() => props.link.links.length > 0);

    const getLink = computed(() => hasLinks.value ? props.link.links[0] : null);

    const getLogo = (): string => {
      return ATTACHMENT_ENDPOINTS.GET(String(props.link.imageId)).url;
    };

    async function goToLink() {
      await router.push({
        name: 'useful-link-view',
        params: {
          usefulLinkId: (props.link.id as number).toString(),
        },
      });
    }

    const { isMobile } = useDeviceSize();

    return {
      props,
      isMobile,
      getLinkName,
      hasLogo,
      hasLinks,
      getLink,
      getLogo,
      getLinkDate,
      goToLink,
      getLinkShortDescription,
    };
  },
});
